<template>
  <div :style="heights?'border:none':'border: 1px solid #ccc;'">
    <Toolbar
      v-show="!heights"
      style="border-bottom: 1px solid #ccc"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      :style="heights?'height: 100%':'min-height: 700px'"
      style="overflow-y: hidden;"
      v-model="html"
      v-if="(!heights)||html"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
      @onChange="onChange"
    />
  </div>
</template>

<script>
  import { DomEditor } from '@wangeditor/editor'
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
  import Config from "@/components/Config.vue";
  export default{
    components: { Editor, Toolbar },
    data() {
      return {
        editor: null,//示例
        html: '',//默认
        toolbarConfig: {
          excludeKeys : [
            'code',
            'sup',
            'sub',
            'emotion',
            'insertImage',
            // 'updateImage',
            'insertVideo',
            // 'group-image',
            'uploadVideo',
            'group-video',
            'codeBlock'
          ]
        },//工具栏配置
        editorConfig: {
          placeholder: '请输入内容...',
          MENU_CONF:{}
        },//编辑器配置
        mode: 'default', // or 'simple'
      }
    },
    created(){
      // this.editorConfig.MENU_CONF['fontSize'] = {
      //   fontSizeList:[
      //     '36px','72px'
      //   ]
      // }
      this.editorConfig.MENU_CONF['uploadImage'] = {
        // 后端上传地址，必填
        server: Config.apiUrl + "/api/store/v0.1/upload/",

        timeout: 5 * 1000, // 5s 超时时间

        fieldName: 'file',

        //选择文件时的类型限制，默认为['image/*'] 如不想限制，则设置为 []
        allowedFileTypes: ['image/*'],

        metaWithUrl: true, // 参数拼接到 url 上

        maxFileSize: 10 * 1024 * 1024, //1g //设置大点 不然图片过大会报错

        uploadImgShowBase64:true,

        base64LimitSize: 5000 * 1024, // 1g 以下插入 base64

        // 上传前
        onBeforeUpload(file) {
          console.log('onBeforeUpload', file)
          // Message({
          //                 message: '图片正在上传中,请耐心等待',
          //                 duration: 0,
          //                 customClass: 'uploadTip',
          //                 iconClass: 'el-icon-loading',
          //                 showClose: true
          //               });
          return files;
          // return file.url // 返回哪些文件可以上传
          // return false 会阻止上传
        },
        // 上传进度的回调函数
        onProgress(progress) {
          console.log('onProgress', progress)
        },
        // 单个文件上传成功之后
        onSuccess(file, res) {
          console.log('onSuccess', file.url, res)
        },
        // 单个文件上传失败
        onFailed(file, res) {
          alert(res.message)
          console.log('onFailed', file, res)
        },
        // 上传错误，或者触发 timeout 超时
        onError(file, err, res) {
          alert(err.message)
          console.error('onError', file, err, res)
        },

      }
    },
    mounted() {
      console.log(this.valueHtml,"ggggggggggg")
      // 模拟 ajax 请求，异步渲染编辑器
      //  setTimeout(() => {
      //    this.html = this.valueHtml
      //  }, 1500)
    },
    methods: {
      onCreated(editor) {
        this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        this.html = this.valueHtml;
      },
      onChange(editor){
        this.editor = Object.seal(editor)
        let toolbar = DomEditor.getToolbar(editor);
        let toolbarConfig = toolbar.getConfig();
        console.log(toolbarConfig,"kk")
        if(this.selectDisabled){
          this.editor.disable()
        }
        console.log(this.html,"看看哈")
        // console.log(this.getEditorHtML(),"瞅瞅哈")
        this.$emit("child-event",this.html);
      },
      getEditorHtML(){
        let editor = this.editor;
        if(editor){
          return editor.getEditorHtML();
        }else {
          return
        }
      }
    },
    watch:{
      valueHtml:{
        deep:true,
        immediate:true,
        handler(){
          this.html = this.valueHtml
        }
      }
    },
    props: {
      selectDisabled: {
        type: Boolean,
        default: false
      },
      valueHtml: {
        type: String,
        default: ""
      },
      heights:{
        type:Boolean,
        default: false
      }
    },
    beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
    }
  }
</script>

<style src="@wangeditor/editor/dist/css/style.css">
</style>
<style>
  .w-e-textarea-1 p{
    margin:0px !important;
  }
  .w-e-text-container [data-slate-editor] p{
    margin:0px !important;
  }
</style>
